angular.module("componentes").directive("forgottenPasswordForm", [
	"$timeout",
	function ($timeout) {
		"use strict";
		return {
			scope: {},
			controller: "ForgottenPasswordFormCtrl",
			controllerAs: "ctrl",
			templateUrl: "views/login/components/forgottenPasswordForm_template.html"
		};
	}
]);
